import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase/app";
import "firebase/database";
import "firebase/firestore";
import "firebase/auth";
import router from "../router";
import Login from "../views/Login.vue";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    cards: [],
    user: {},
    currentGame: {
      status: "",
      schedule: new Date(),
      uid: ""
    },
    sheets: [],
    info: {}
  },
  mutations: {
    SET_GAME_ID(state, payload) {
      state.currentGame = payload;
    },
    SET_GAME_CARD(state, payload) {
      state.cards = payload;
    },
    SET_GAME_STATUS(state, payload) {
      state.currentGame.status = payload;
    },
    SET_USER(state, payload) {
      state.user = payload;
    },
    SET_INFO(state, payload) {
      state.info = payload;
    },
    SET_GAME_SHEET(state, payload) {
      state.sheets = payload;
    }
  },
  actions: {
    openLoginModel() {
      this._vm.$buefy.modal.open({
        parent: this,
        component: Login,
        hasModalCard: true,
        customClass: "custom-class custom-class-2",
        trapFocus: true
      });
    },
    // eslint-disable-next-line no-empty-pattern
    login({}, form) {
      return firebase.auth().signInWithEmailAndPassword(form.email, form.password);
    },
    async logout() {
      await firebase.auth().signOut();
      router.push("/login");
    },
    async forgot(unused, email) {
      return firebase.auth().sendPasswordResetEmail(email);
    },
    async fetchCards({ commit }, gameId) {
      await new Promise((res) => {
        firebase
          .database()
          .ref("games")
          .child(gameId)
          .on("value", (snap) => {
            const data = snap.val();
            let cards = [];
            if (!data || !data.cards) return;
            for (const [key, value] of Object.entries(data.cards)) {
              let number = key.padStart(3, "0");
              cards.push({ ...value, phone: null, number });
            }
            res(true);
            commit("SET_GAME_CARD", cards);
            if (data.data.sheetUsers) {
              commit("SET_GAME_SHEET", data.data.sheetUsers);
            }
            return;
          });
      });
    },
    async fetchStatus({ commit, dispatch }) {
      let dataSnap = await firebase
        .firestore()
        .collection("games")
        .where("status", "in", ["live", "schedule", "winner_declared"])
        .orderBy("schedule", "desc")
        .get();
      let data = dataSnap.docs;
      if (dataSnap.empty) {
        return "nogame";
      }
      let is_live = data.find((game) => game.data().status == "live");
      if (is_live) {
        commit("SET_GAME_ID", { ...is_live.data(), uid: is_live.id });
        await dispatch("fetchCards", is_live.id);
        return "live";
      }
      let schedule_game = data.find((game) => game.data().status == "schedule");
      if (schedule_game) {
        commit("SET_GAME_ID", { ...schedule_game.data(), uid: schedule_game.id });
        await dispatch("fetchCards", schedule_game.id);
        return "/";
      }
      commit("SET_GAME_ID", { ...data[0].data(), uid: data[0].id });
      await dispatch("fetchCards", data[0].id);
      return "live";
    },
    async fetchInfo() {
      const dbRef = firebase.database().ref("info");
      const snap = await dbRef.once("value");
      if (snap.exists()) {
        this.commit("SET_INFO", snap.val());
      }
      return snap;
    }
  },
  modules: {}
});
